import { hsCss as css } from 'src/features/ttx/landing-sections/ttx-home/components/get-started/get-started.constants';

export const hsCss = (isDarkMode: boolean) => {
  return `${css}
    .hs-submit {
      display: flex;
      justify-content: flex-end;
      border-top: 0.1rem solid ${isDarkMode ? 'rgb(62, 71, 90)' : `rgb(212, 216, 223)`};
      padding-top: 18px;
      margin-top: 46px;
    }

    form label {
      color: ${isDarkMode ? 'rgb(249, 249, 251)' : 'rgb(21, 28, 43)'};
    }

    .hs-input {
      background-color: ${isDarkMode ? 'rgb(21, 28, 43)' : 'rgb(249, 249, 251)'};
      border-color: ${isDarkMode ? 'rgb(62, 71, 90)' : 'rgb(212, 216, 223)'};
      color: ${isDarkMode ? 'rgb(249, 249, 251)' : 'rgb(21, 28, 43)'};
    }

    .hs-submit .actions input {
      cursor: pointer;
      margin: 0;
    }

    .hs-fieldtype-textarea {
      height: 128px;
    }

    .hs_job_role .input,
    .hs_seats_required .input {
      position: relative;
    }

    .hs_job_role .input::after,
    .hs_seats_required .input::after {
      content: '\\f078';
      font-family: 'Font Awesome 6 Pro', 'Font Awesome 5 Pro';
      font-weight: 900;
      position: absolute;
      right: 12px;
      top: 50%;
      transform: translateY(-50%);
      color: rgba(135, 143, 162, 1);
      font-size: 12px;
      pointer-events: none;
    }

    @media (max-width: 768px) {
      .hs-submit,
      .hs-submit .actions,
      .hs-submit .actions input {
        width: 100%;
      }

      .hs-submit {
        margin-bottom: 50px;
      }
    }

    @media (max-width: 480px) {
      .form-columns-2 {
        display: flex;
        flex-direction: column;
      }

      .form-columns-2 div {
        width: 100% !important
      }
    }
  `;
};
